import { render } from "./BaseFilter.vue?vue&type=template&id=452fd876&scoped=true"
import script from "./BaseFilter.vue?vue&type=script&lang=js"
export * from "./BaseFilter.vue?vue&type=script&lang=js"

import "./BaseFilter.vue?vue&type=style&index=0&id=452fd876&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452fd876"]])

export default __exports__